import { render, staticRenderFns } from "./PopUpParticipantsFile.vue?vue&type=template&id=a9d87300&scoped=true&"
import script from "./PopUpParticipantsFile.vue?vue&type=script&lang=js&"
export * from "./PopUpParticipantsFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpParticipantsFile.vue?vue&type=style&index=0&id=a9d87300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d87300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9d87300')) {
      api.createRecord('a9d87300', component.options)
    } else {
      api.reload('a9d87300', component.options)
    }
    module.hot.accept("./PopUpParticipantsFile.vue?vue&type=template&id=a9d87300&scoped=true&", function () {
      api.rerender('a9d87300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpParticipantsFile.vue"
export default component.exports